module.exports = "/_next/static/images/andrewklajbor-994ddd3f95f228199fc35040f465e11d.jpg";